import axios from "axios";
import { Toast } from "vant";
import Cookies from 'js-cookie';
axios.defaults.baseURL = JSON.parse(Cookies.get("school")).baseUrl;
axios.defaults.timeout = 15 * 1000;
//axios.defaults.withCredentials = true;
axios.interceptors.request.use(
    (config) => {
        Toast.loading({
            duration: 0,
            forbidClick: true,
        });
        config.headers["Content-Type"] = "application/json;charset=utf-8";
        config.headers["Accept"] = "application/json";
        return config;
    },
    (error) => {
        Toast.clear();
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    (res) => {
        Toast.clear();
        if (res.status === 200) {
            if (res.data.msg.indexOf("重新登录")>0) {
                Toast({
                    message: '由于您长时间未操作，正在重新登录',
                    forbidClick:true
                })
                setTimeout(()=>{
                    Toast.clear();
                    let prefix = window.location.href.split('#')[0];
                    window.location.href = prefix + "wx/check?school="+JSON.parse(Cookies.get("school")).school;
                    return false;
                },2000);
            } else if (res.data.msg.indexOf("Error")>0) {
                let err = {};
                err.message = "网络连接错误，请重试";
                return Promise.reject(err);
            } else {
                return res.data;
            }
            
        } else {
            Toast({
                message: '系统繁忙，请稍后再试',
                forbidClick: true,
                overlay: true,
            });
            return Promise.reject(res.data);
        }
    },
    (error) => {
        // 弹窗提示错误信息
        Toast({
            message: '系统繁忙，请稍后再试',
            forbidClick: true,
            overlay: true,
        });
        return Promise.reject(error);
    }
);

export default axios;